import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import {
  Tabs,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs"

import { DashboardRecurringTabContent } from "./recurring-tab-content"
import { DashboardRotateTabContent } from "./rotate-tab-content"

type DashboardChartsAreaProps = SearchParamsType
export const DashboardChartsArea: React.FC<
  DashboardChartsAreaProps
> = ({ searchParams }) => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState<string>(() => {
    const hash = window.location.hash.replace("#", "")
    return hash === "rotativo" ? "rotate" : "recurring"
  })

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "")
      setActiveTab(
        hash === "rotativo" ? "rotate" : "recurring"
      )
    }

    window.addEventListener("hashchange", handleHashChange)
    return () =>
      window.removeEventListener(
        "hashchange",
        handleHashChange
      )
  }, [])

  const handleTabChange = (value: string) => {
    setActiveTab(value)
    window.location.hash =
      value === "rotate" ? "rotativo" : "recorrencia"
  }

  return (
    <Tabs value={activeTab} onValueChange={handleTabChange}>
      <TabsList>
        <TabsTrigger value="recurring">
          {t("pages.dashboard.tabs.recurring")}
        </TabsTrigger>
        <TabsTrigger value="rotate">
          {t("pages.dashboard.tabs.rotate")}
        </TabsTrigger>
      </TabsList>
      <DashboardRecurringTabContent
        searchParams={searchParams}
        isActive={activeTab === "recurring"}
      />
      <DashboardRotateTabContent
        searchParams={searchParams}
        isActive={activeTab === "rotate"}
      />
    </Tabs>
  )
}
